// extracted by mini-css-extract-plugin
export default {"base":"AppBase_base__Lf5o0","withoutMessage":"AppBase_withoutMessage__fuaP3","baseSm":"AppBase_baseSm__PoaPt","baseFloating":"AppBase_baseFloating__dg0T-"};